import React, { useRef, useState, useEffect } from 'react';
import classnames from 'classnames';
import { s as styleInject } from './style-inject.es-4a6aca40.js';

var css_248z = ".sunzi_components__loadingLine-mpaBb {\n  width: 100%;\n}\n.sunzi_components__loadingLine-mpaBb .sunzi_components__progress-2OMGK {\n  position: relative;\n  width: 100%;\n  height: 12px;\n  background: #d0d0d0;\n  border-radius: 4px;\n}\n.sunzi_components__loadingLine-mpaBb .sunzi_components__progressDone-3dzWy {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  background-image: -webkit-gradient(linear, left top, right top, from(#ff0136), to(#ff6786));\n  background-image: -webkit-linear-gradient(left, #ff0136, #ff6786);\n  background-image: -o-linear-gradient(left, #ff0136, #ff6786);\n  background-image: linear-gradient(to right, #ff0136, #ff6786);\n  border-radius: 4px;\n  -webkit-box-shadow: 0 3px 5px rgba(255, 1, 54, 0.4);\n          box-shadow: 0 3px 5px rgba(255, 1, 54, 0.4);\n}\n.sunzi_components__loadingLine-mpaBb .sunzi_components__progressDoneImitate-ZGsqF {\n  width: 90%;\n  -webkit-animation: sunzi_components__progress-2OMGK 8s cubic-bezier(0.645, 0.045, 0.355, 1);\n          animation: sunzi_components__progress-2OMGK 8s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.sunzi_components__loadingLine-mpaBb .sunzi_components__percent-1QoIj {\n  padding-top: 8px;\n  color: #313131;\n  font-weight: bold;\n  font-size: 12px;\n  text-align: right;\n}\n@-webkit-keyframes sunzi_components__progress-2OMGK {\n  0% {\n    width: 0%;\n  }\n  50% {\n    width: 80%;\n  }\n  100% {\n    width: 90%;\n  }\n}\n@keyframes sunzi_components__progress-2OMGK {\n  0% {\n    width: 0%;\n  }\n  50% {\n    width: 80%;\n  }\n  100% {\n    width: 90%;\n  }\n}\n";
var styles = {"loadingLine":"sunzi_components__loadingLine-mpaBb","progress":"sunzi_components__progress-2OMGK","progressDone":"sunzi_components__progressDone-3dzWy","progressDoneImitate":"sunzi_components__progressDoneImitate-ZGsqF","percent":"sunzi_components__percent-1QoIj"};
styleInject(css_248z);

var Loading = function (_a) {
  var _b = _a.percent,
      percent = _b === void 0 ? 0 : _b;

  var _progress = useRef(null);

  var _progressDone = useRef(null);

  var _c = useState(0),
      width = _c[0],
      setWidth = _c[1];

  useEffect(function () {
    animate();
  }, []);
  useEffect(function () {
    if (percent > 90) setWidth(percent);
  }, [percent]);

  var animate = function () {
    if (_progress.current && _progressDone.current && percent < 90) {
      setWidth(_progressDone.current.offsetWidth * 100 / _progress.current.offsetWidth);
      requestAnimationFrame(animate);
    }
  };

  return React.createElement("div", {
    className: styles.loadingLine
  }, React.createElement("div", {
    ref: _progress,
    className: styles.progress
  }, percent < 90 ? React.createElement("div", {
    ref: _progressDone,
    className: classnames('progress-done', styles.progressDone, styles.progressDoneImitate)
  }) : React.createElement("div", {
    className: classnames('progress-done', styles.progressDone),
    style: {
      width: width + "%"
    }
  })), React.createElement("div", {
    className: styles.percent,
    style: {
      width: width + "%"
    }
  }, width.toFixed(), "%"));
};

export default Loading;
